// extracted by mini-css-extract-plugin
export default {"listReviews":"vzRiS","review":"n_EGP","wrapperNav":"oRyTn"};